<template>
    <transition appear name="fade-transition">
        <v-img height="100vh" :src="background">
            <div class="app-full-height d-flex flex-column align-start justify-center" style="padding: 2rem 8rem">
                <app-card v-if="isRegistrationError">
                    <template #title>There is a problem with your registration.</template>
                    <p>
                        Unfortunately, we can't automatically proceed with your application. Your application has been
                        sent to our Client Services team for review and we will be in touch to discuss the next steps.
                    </p>
                    <p>
                        You can contact our Client Services team by calling
                        <app-link to="tel:03003030037">0300 3030 037</app-link> or by emailing
                        <app-link to="mailto:clientservices@growthinvest.com">clientservices@growthinvest.com</app-link>
                    </p>
                    <template #footer>
                        <app-button
                            v-if="env !== 'live' && registration.id"
                            secondary
                            :text="$t('reset')"
                            class="mr-2"
                            @click="onResetAttempts"
                        />
                        <app-logout-button v-if="signoutUrl" :text="$t('back_to_login')" :signout-url="signoutUrl" />
                    </template>
                </app-card>

                <app-card v-if="isRecategorisationError">
                    <template #title>There is a problem with your recategorisation</template>
                    <p>
                        Unfortunately, we can't automatically proceed with your recategorisation due to the answers you
                        provided. Your application has been sent to our Client Services team for review and we will be
                        in touch to discuss the next steps.
                    </p>
                    <p>
                        You can contact our Client Services team by calling
                        <app-link to="tel:03003030037">0300 3030 037</app-link> or by emailing
                        <app-link to="mailto:clientservices@growthinvest.com">clientservices@growthinvest.com</app-link>
                    </p>
                    <template #footer>
                        <app-logout-button v-if="signoutUrl" :text="$t('back_to_login')" :signout-url="signoutUrl" />
                    </template>
                </app-card>

                <app-card v-if="isSuspendedError">
                    <template #title>Pending review</template>
                    <p>
                        Unfortunately, you can't access the platform at the moment. Your account has been flagged to our
                        Client Services team for review and we will be in touch to discuss the next steps.
                    </p>
                    <p>
                        You can contact our Client Services team by calling
                        <app-link to="tel:03003030037">0300 3030 037</app-link> or by emailing
                        <app-link to="mailto:clientservices@growthinvest.com">clientservices@growthinvest.com</app-link>
                    </p>
                    <template #footer>
                        <app-logout-button v-if="signoutUrl" :text="$t('back_to_login')" :signout-url="signoutUrl" />
                    </template>
                </app-card>
            </div>
        </v-img>
    </transition>
</template>

<script>
import Auth from '@/models/Auth';
import { Registration } from '@/models';
import config from '@/config';
import FatalErrorTypeEnum from '@/enums/fatalErrorType';

export default {
    name: 'FatalError',
    beforeRouteEnter: (to, from, next) => {
        const type = to.query.type;

        if (type === FatalErrorTypeEnum.REGISTRATION) {
            if (Auth().is_logged_in) {
                next({ name: 'Dashboard' });
            }
        }

        next();
    },
    data: () => ({
        background: require('@/images/background.jpg'),
        registration: new Registration(),
        env: config.APP_ENV
    }),
    computed: {
        signoutUrl() {
            return this.$route.query.signout_url || null;
        },
        isRegistrationError() {
            return this.$route.query.type === FatalErrorTypeEnum.REGISTRATION;
        },
        isRecategorisationError() {
            return this.$route.query.type === FatalErrorTypeEnum.RECATEGORISATION;
        },
        isSuspendedError() {
            return this.$route.query.type === FatalErrorTypeEnum.SUSPENDED;
        }
    },
    mounted() {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.documentElement.style.overflow = null;
        document.body.style.overflow = null;
    },
    methods: {
        async setup() {
            try {
                if (this.isRegistrationError) {
                    const reg = await Registration.api.get();
                    if (reg && reg.data && reg.data.length > 0) {
                        this.registration = new Registration(reg.data[0]);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        async onResetAttempts() {
            await this.registration.$update({
                investor_type_attempts: 0,
                on_boarding_status: 'PENDING'
            });

            this.$router.push({ name: 'InvestorOnboarding' });
        }
    }
};
</script>
